import { render, staticRenderFns } from "./Kurs.vue?vue&type=template&id=6842b112"
import script from "./Kurs.vue?vue&type=script&lang=js"
export * from "./Kurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports